export default "__VITE_ASSET__3fe80f9e__"